import { render, staticRenderFns } from "./LawDocumentContentTypeForm.vue?vue&type=template&id=2759b7b9&"
import script from "./LawDocumentContentTypeForm.vue?vue&type=script&lang=js&"
export * from "./LawDocumentContentTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./LawDocumentContentTypeForm.vue?vue&type=style&index=0&id=2759b7b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports